import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownOption from "components/Common/DropdownOption";
import DropdownPoolOption from "components/Common/DropdownPoolOption";
import LabelWrapper from "components/Common/LabelWrapper";
import { useFormik } from "formik";
import { LINK_FOR_NO_IMAGE } from "helpers/constans";
import { customToFixed } from "helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { getAllWallets, getPoolTokenBalance, getQuote, postSwap } from "store/thunks";
import * as Yup from "yup";
export interface Props {
    isOpen?: boolean;
    detail?: any | null,
    listPool: any[],
    onClose?: () => void
    triggerRefresh?: (type?: string) => void;
}

const SwapForm = ({
    isOpen = false,
    detail = null,
    listPool = [],
    onClose,
    triggerRefresh
}: Props) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const OPTION_POOLS = listPool;

    const [listWallet, setListWallet] = useState<any[]>([]);

    const [poolSelect, setPoolSelect] = useState<any>(null);

    const [tokenBalance, setTokenBalance] = useState<any>({});

    const [isColumnReverse, setIsColumnReverse] = useState<boolean>(false);

    const SLIPPAGE_OPTIONS = [{ label: '0.0%', value: '0' }, { label: '0.3%', value: '0.003' }, { label: '0.5%', value: '0.005' }, { label: '1.0%', value: '0.01' }, { label: '2.0%', value: '0.02' }, { label: '3.0%', value: '0.03' }, { label: '4.0%', value: '0.04' }, { label: '5.0%', value: '0.05' }];

    const onCloseClick = () => {
        onClose && onClose();
        setPoolSelect(() => null);
        setTokenBalance({});
        formik.resetForm();
    };

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);
            const slippage = Number(values?.slippage?.value || SLIPPAGE_OPTIONS[2]?.value);

            const amountA = Number(values?.amount_a) * Math.pow(10, Number(poolSelect?.data?.tokenDecimals1));
            const amountB = Number(values?.amount_b) * Math.pow(10, Number(poolSelect?.data?.tokenDecimals2));

            const amountSlippageA = Number(Number(amountA * slippage).toFixed());
            const amountSlippageB = Number(Number(amountB * slippage).toFixed());

            const typeInput = values?.type_input;
            const amountIn = typeInput === 'a' ? amountA : amountB;
            const amountOut = typeInput === 'a' ? amountB : amountA;
            const amountSlippage = typeInput === 'a' ? amountSlippageB : amountSlippageA;

            const addressIn = typeInput === 'a' ? values?.address_a : values?.address_b;

            const aTob = values?.a_to_b;
            const amountSpecifiedIsInput = (aTob && addressIn === poolSelect?.data?.tokenA) || (!aTob && addressIn === poolSelect?.data?.tokenB);

            const amountThreshold = amountSpecifiedIsInput ? 0 : (Number(amountOut) + Number(amountSlippage));

            const walletId = (values?.owner as any)?.value || '';

            const data = {
                pool: poolSelect?.value || '',
                walletId: Number(walletId),
                amountIn: amountIn,
                amountThreshold: amountThreshold,
                aTob: Boolean(aTob),
                amountSpecifiedIsInput: Boolean(amountSpecifiedIsInput),
                // sqrtPriceStr: values?.sqrtPriceStr || ''
            };

            const response: any = await postSwap(data);
            if (response?.data) {
                setIsLoading((_prev) => false);
                toast(
                    <div>
                        {t("The process has been completed.")} -
                        <a href={`https://solscan.io/tx/${Array.isArray(response?.data) ? response?.data?.[0] : (response?.data || '')}`} className="text-primary text-decoration-underline" target="_blank" rel="noopener noreferrer">TX</a>
                    </div>,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                onCloseClick();
            } else {
                setIsLoading((_prev) => false);
                toast(`${response || 'Error - Plz try again!'}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || 'Error - Plz try again!'}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        amount_a: Yup.number().nullable(),
        address_a: Yup.string().required(`${t("This is required")}`),
        amount_b: Yup.number().nullable(),
        address_b: Yup.string().required(`${t("This is required")}`),
        quote: Yup.number().nullable(),
        slippage: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).nullable(),
        type_input: Yup.string().required(`${t("This is required")}`),
        a_to_b: Yup.boolean(),
        owner: Yup.object().shape({
            label: Yup.string(),
            value: Yup.string(),
        }).required(`${t("This is required")}`),

    });

    const formik = useFormik({
        initialValues: {
            amount_a: '',
            address_a: '',
            amount_b: '',
            address_b: '',
            type_input: 'a',
            quote: 0,
            slippage: SLIPPAGE_OPTIONS[2],
            a_to_b: true,
            owner: null,
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const _amount_a = detail?.amount_a || '';
                const _address_a = detail?.address_a || '';
                const _amount_b = detail?.amount_b || '';
                const _address_b = detail?.address_b || '';

                const _type_input = detail?.type_input || 'a';
                const _quote = detail?.quote || 0;
                const _a_to_b = detail?.a_to_b || false;

                const _slippage = SLIPPAGE_OPTIONS[2];

                formik.setFieldValue('amount_a', _amount_a);
                formik.setFieldValue('address_a', _address_a);
                formik.setFieldValue('amount_b', _amount_b);
                formik.setFieldValue('address_b', _address_b);

                formik.setFieldValue('type_input', _type_input);
                formik.setFieldValue('quote', _quote);
                formik.setFieldValue('slippage', _slippage);
                formik.setFieldValue('a_to_b', _a_to_b);

                setTimeout(() => {
                    formik.setErrors({});
                }, 300);
            } catch (error: any) {
                // setIsLoadingDetail((_prev) => false);
                return error;
            }
        };
        handleCallAllOption();
    }, [JSON.stringify(detail)]);


    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const data_param = {
                    owner: (formik?.values?.owner as any)?.label || '',
                    pool: poolSelect?.value || ''
                };
                const [res1, res2]: any = await Promise.all([getQuote({ pair: poolSelect?.value }), getPoolTokenBalance(data_param)]);
                formik.setFieldValue('quote', Number(res1?.data || 0));
                formik.setFieldValue('a_to_b', poolSelect?.data?.aToB);
                formik.setFieldValue('amount_a', 0);
                formik.setFieldValue('amount_b', 0);
                formik.setFieldValue('address_a', poolSelect?.data?.tokenAddress1);
                formik.setFieldValue('address_b', poolSelect?.data?.tokenAddress2);
                setTokenBalance((_prev: any) => res2?.tokens || {});
                setIsColumnReverse((_prev) => false);
            } catch (error: any) {
                // setIsLoadingDetail((_prev) => false);
                return error;
            }
        };
        if (!!poolSelect?.value && !!(formik?.values?.owner as any)?.value) {
            handleCallAllOption();
        }
    }, [JSON.stringify(poolSelect?.value), formik?.values?.owner]);


    const handleChangeAtoB = () => {
        if (!poolSelect?.value) {
            return;
        }
        formik.setFieldValue('a_to_b', !formik?.values?.a_to_b);
        setIsColumnReverse((_prev) => !_prev);
    };

    useEffect(() => {
        const handleCallAllOption = async () => {
            const response: any = await getAllWallets();
            const _listWallet = response?.data?.map((_item: any) => ({ label: _item?.wallets?.pubkey, value: _item?.wallets?.ID }));
            setListWallet((_prev: any) => _listWallet);
        };
        if (!!isOpen) {
            handleCallAllOption();
        }
    }, [isOpen]);

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                // className={`border-header-footer`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick} className="modal-title-flex-grow-1 pb-3 border border-dashed border-end-0 border-start-0 border-top-0">
                    <div className="d-flex flex-column gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            <>{t('Create Swap')}</>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <div>
                        <form onSubmit={formik.handleSubmit}>
                            <Row>
                                <Col sm={12}
                                    md={6}
                                    xl={12}
                                    xxl={12}
                                    className="mt-2 mb-2"
                                >
                                    <div className="d-flex gap-3">
                                        <div className="flex-grow-1">
                                            <LabelWrapper label={t('Label_Pool')} isShow={true}>
                                                <DropdownPoolOption
                                                    isMultiLang
                                                    name="pool"
                                                    dataList={OPTION_POOLS}
                                                    initialValue={poolSelect || null}
                                                    onChangeSelect={(event: any) => {
                                                        setPoolSelect((_prev: any) => event);
                                                        formik.setFieldValue('address_a', event?.data?.tokenAddress1 || '');
                                                        formik.setFieldValue('address_b', event?.data?.tokenAddress2 || '');
                                                    }}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    isShowMore={true}
                                                    // className="bg-[#fff]"
                                                    labelTop=""
                                                    isHasOptionAll={true}
                                                    optionAll={{
                                                        label: t('None'),
                                                        value: ''
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </div>
                                        <div style={{ width: '100px' }}>
                                            <LabelWrapper label={t('Slippage')} isShow={true}>
                                                <DropdownOption
                                                    name="slippage"
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    dataList={SLIPPAGE_OPTIONS}
                                                    initialValue={formik?.values?.slippage || SLIPPAGE_OPTIONS[2]}
                                                    onChangeSelect={(event: any) => {
                                                        formik.setFieldValue('slippage', event);
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12}
                                    md={6}
                                    xl={12}
                                    xxl={12}
                                    className="mt-2 mb-3"
                                >
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <LabelWrapper label={t('Wallet')} isShow={true}>
                                                <DropdownOption
                                                    name="owner"
                                                    dataList={listWallet}
                                                    placeholder={`${t('Wallet')}...`}
                                                    className="search-filter-category-type dropdown-status-rounded"
                                                    classNamePrefix="name-prefix"
                                                    initialValue={formik?.values?.owner || null}
                                                    onChangeSelect={(e: any) => formik.setFieldValue("owner", e)}
                                                    isHasOptionAll={true}
                                                    optionAll={{ label: t('None'), value: '' }}
                                                />
                                            </LabelWrapper>
                                        </div>
                                    </div>
                                    {formik.touched.owner && formik.errors.owner ? (
                                        <div className="text-danger mt-2">{formik.errors.owner}</div>
                                    ) : null}
                                </Col>
                                <div className={`d-flex position-relative gap-2 ${isColumnReverse ? 'flex-column-reverse' : 'flex-column'}`}>
                                    <div className="position-absolute bg-primary-subtle cursor-pointer" style={{
                                        left: '50%',
                                        top: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        fontSize: '22px',
                                        border: '1px solid var(--vz-primary)',
                                        width: '30px',
                                        height: '30px',
                                        textAlign: 'center',
                                        borderRadius: '4px',
                                        zIndex: '1'
                                    }}
                                        onClick={() => handleChangeAtoB()}
                                    >
                                        <i className="bx bx-sort-alt-2 text-primary" />
                                    </div>
                                    <div
                                        style={{
                                            borderRadius: '10px',
                                            padding: '20px 20px',
                                        }}
                                        className="bg-primary-subtle"
                                    >
                                        <Row>
                                            <Col sm={12} lg={12} className="mb-3">
                                                <Label htmlFor="amount_a" className="form-label">{t('Amount')} <span className="text-danger"> *</span></Label>
                                                <div className="position-relative">
                                                    <Input
                                                        name="amount_a"
                                                        type="text"
                                                        className="form-control fs-18"
                                                        id="amount_a"
                                                        placeholder={'0.0'}
                                                        value={formik?.values?.amount_a}
                                                        onChange={(event: any) => {
                                                            const input = event.target.value;
                                                            const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                            const s = onlyNumbers;
                                                            const quote = Number(formik?.values?.quote || 0);
                                                            formik.setFieldValue("amount_a", s);
                                                            formik.setFieldValue("amount_b", customToFixed(Number(s * quote), poolSelect?.data?.tokenDecimals2));
                                                            formik.setFieldValue('type_input', 'a');
                                                        }}
                                                    />
                                                    <div
                                                        style={{ bottom: 5, right: 20 }}
                                                        className="position-absolute fw-medium text-secondary"
                                                    >
                                                        <div className="d-flex justify-content-end align-items-end gap-1">
                                                            <div className="text-center m-auto w-[24px]">
                                                                <img
                                                                    src={poolSelect?.data?.logo1 || LINK_FOR_NO_IMAGE}
                                                                    style={{
                                                                        width: "24px",
                                                                        height: "24px",
                                                                        borderRadius: "12px",
                                                                    }}
                                                                    className="flex-shrink-0 object-fit-cover m-auto w-[24px] h-[24px] !rounded-full"
                                                                    alt="token"
                                                                />
                                                            </div>
                                                            <div className="fs-22 mb-0">
                                                                {poolSelect?.data?.tokenSymbol1 || '***'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end align-items-end gap-1 text-muted mt-1 text-primary">
                                                    <span className="text-primary">
                                                        {tokenBalance?.tokenA?.address === poolSelect?.data?.tokenAddress1 ? (
                                                            tokenBalance?.tokenA?.balance?.uiAmount
                                                        ) : (
                                                            tokenBalance?.tokenB?.balance?.uiAmount
                                                        )}
                                                    </span>
                                                    <i className="ri-wallet-3-line text-primary align-bottom" />
                                                </div>

                                                {formik.touched.amount_a && formik.errors.amount_a ? (
                                                    <div className="text-danger mt-2">{formik.errors.amount_a}</div>
                                                ) : null}
                                            </Col>
                                        </Row>
                                    </div>
                                    <div
                                        className="bg-primary-subtle"
                                        style={{
                                            borderRadius: '10px',
                                            padding: '20px 20px',
                                        }}
                                    >
                                        <Row>
                                            <Col sm={12} lg={12} className="mb-3">
                                                <Label htmlFor="amount_b" className="form-label">{t('Amount')} <span className="text-danger"> *</span></Label>
                                                <div className="position-relative">
                                                    <Input
                                                        name="amount_b"
                                                        type="text"
                                                        className="form-control fs-18"
                                                        id="amount_b"
                                                        placeholder={'0.0'}
                                                        value={formik?.values?.amount_b}
                                                        onChange={(event: any) => {
                                                            const input = event.target.value;
                                                            const onlyNumbers = input.replace(/[^0-9.]/g, "");
                                                            const s = onlyNumbers;
                                                            const quote = Number(formik?.values?.quote || 0);
                                                            const xx = quote === 0 ? 0 : (Number(s) / quote);
                                                            formik.setFieldValue("amount_b", s);
                                                            formik.setFieldValue("amount_a", customToFixed(Number(xx || 0), poolSelect?.data?.tokenDecimals1));
                                                            formik.setFieldValue('type_input', 'b');
                                                        }}
                                                    />
                                                    <div
                                                        style={{ bottom: 5, right: 20 }}
                                                        className="position-absolute fw-medium text-secondary"
                                                    >
                                                        <div className="d-flex justify-content-end align-items-end gap-1">
                                                            <div className="text-center m-auto w-[24px]">
                                                                <img
                                                                    src={poolSelect?.data?.logo2 || LINK_FOR_NO_IMAGE}
                                                                    style={{
                                                                        width: "24px",
                                                                        height: "24px",
                                                                        borderRadius: "12px",
                                                                    }}
                                                                    className="flex-shrink-0 object-fit-cover m-auto w-[24px] h-[24px] !rounded-full"
                                                                    alt="token"
                                                                />
                                                            </div>
                                                            <div className="fs-22 mb-0">
                                                                {poolSelect?.data?.tokenSymbol2 || '***'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end align-items-end gap-1 text-muted mt-1 text-primary">
                                                    <span className="text-primary">
                                                        {tokenBalance?.tokenB?.address === poolSelect?.data?.tokenAddress2 ? (
                                                            tokenBalance?.tokenB?.balance?.uiAmount
                                                        ) : (
                                                            tokenBalance?.tokenA?.balance?.uiAmount
                                                        )}
                                                    </span>
                                                    <i className="ri-wallet-3-line text-primary align-bottom" />
                                                </div>
                                                {formik.touched.amount_b && formik.errors.amount_b ? (
                                                    <div className="text-danger mt-2">{formik.errors.amount_b}</div>
                                                ) : null}
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <Col sm={12} className="mb-2 mt-3" >
                                    <div className="d-flex gap-3 justify-content-end align-item-center">
                                        <button
                                            className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center bg-[#009ef7] hover:bg-[#0086d2]"
                                            type="submit"
                                            style={{ width: '150px' }}
                                            disabled={isLoading}
                                        >
                                            {isLoading && <span style={{ transform: 'translateY(1px)' }} className="me-1"><Spinner size="sm"></Spinner></span>}<span>{
                                                !!detail?.id ? t('Update Wallet') : t('Create Swap')
                                            }</span>
                                        </button>
                                        <button
                                            className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center bg-[#878a99] hover:bg-[#737582]"
                                            type="button"
                                            onClick={onCloseClick}
                                            style={{ width: '75px' }}
                                        >
                                            <span className="ms-1">{t("Button Close")}</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment >
    );
};

export default SwapForm;

